import { AxiosError } from 'axios';
import instance from '../middleware/HTTPInterceptors';
import ErrorResponse from '../utilities/ErrorResponse';
import { HTTPResponse } from '../utilities/frontendTypes';
import * as T from "../utilities/frontendTypes";

interface AxiosErrorData {
  message?: string;
  error?: string;
}

function throwAxiosError(err: unknown, fallbackMessage: string): never {
  const axErr = err instanceof AxiosError ? err : null;
  const data = axErr?.response?.data as AxiosErrorData | undefined;
  throw new ErrorResponse(data?.message || fallbackMessage, axErr?.response?.status || 500);
}


type AutocompleteRequestBodyType = {
  input: string
}
export async function getAutocompleteByInput(input: string): Promise<HTTPResponse> {

  try {

    const reqBody: AutocompleteRequestBodyType = {
      input
    }

    const res = await instance.post("/api/public/places", reqBody);
    
    return res.data;

  } catch (err: unknown) {
    throwAxiosError(err, "Request failed");
  } 
}

export const getPlaceById = async (placeId: string): Promise<HTTPResponse> => {

  try {

    const res = await instance.get(`/api/public/places/${placeId}`);
    
    return res.data;

  } catch (err: unknown) {
    throwAxiosError(err, "Request failed");
  }
};

type Location = {
  lat: number,
  lng: number,
  province: string,
  city?: string,
  postalCode?: string,
  workingWithBai?: string,
}

export const getRegionByLocation = async (location: Location): Promise<T.UserRegion | "notSupported"> => {

  try {

    const res = await instance.post(`/api/public/get-region`, location);

    return res.data.data;

  } catch (err: unknown) {
    throwAxiosError(err, "Request failed");
  }
}

// [TODO] refactor email: {email: string} 
export async function sendPwResetEmail(email: {email: string}): Promise<T.HTTPResponse> {

  try {
    const res = await instance.post(`/api/auth/forgotpassword`, email);

    if (res.status === 200) {
      return res.data
    }

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: unknown) {
    throwAxiosError(err, "Request failed");
  } 
}

// [TODO] refactor password: {password: string} 
export async function resetPassword(resetToken: string, password: {password: string}): Promise<T.HTTPResponse> {

  try {

    const res = await instance.put(`/api/auth/resetpassword/${resetToken}`, password);

    if (res.status === 201) {
      return res.data
    }

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: unknown) {
    throwAxiosError(err, "Request failed");
  } 
}

export const checkEmail = async (email: string): Promise<HTTPResponse> => {

  try {

    const res = await instance.get(`/api/public/check-email/${email}`);
    return res.data;

  } catch (err: unknown) {
    throwAxiosError(err, "Request failed");
  }
};

export const triggerDelayedResponse = async () => {
  try {

    const res = await instance.get(`/api/public/delayed-response`);

    return res.data;

  } catch (err: unknown) {
    throwAxiosError(err, "Request failed");
  }
}

export async function getDownloadUrl(docKey: string): Promise<{success: boolean, url: string }> {
  try {
    const res = await instance.get(`/api/public/get-pdf/${docKey}`);
    
    if (res.status === 200) return res.data;

    throw new ErrorResponse("Request unsuccessful", 400);

  } catch (err: unknown) {
    throwAxiosError(err, "Request failed");
  }
}